
// Maps an array of objects to dropdown-compatible options ({ value, label }).
// Uses the specified Id and Name keys to extract the value and label respectively.
export const getDropdownOptionsNoDefaultVal = (
    optionDetails = [],
    Id = "Id",
    Name = "Name"
) => {
    return optionDetails.reduce((acc, val) => {
        return [
            ...acc,
            {
                value: val[Id],
                label: val[Name],
            },
        ];
    }, []);
};
